<template>
  <BaseField baseRule="" v-bind="$attrs" :label="label" :placeholder="placeholder" v-model="inputValue" />
</template>

<script>
import BaseField from '@/components/forms/BaseField.vue';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  components: {
    BaseField,
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
